import { ArrowLeft } from "lucide-react";

import { Link } from "@/router/router";
import { buttonClass, EmptyState } from "@/ui";

import styles from "./ErrorScreen.module.css";

export function NotFound({ what = "This page" }: { what?: string }) {
  return (
    <main className={styles.screen}>
      <EmptyState
        headingLevel={2}
        title={`${what} doesn't exist`}
        description="The link may be old, or you may not have access."
        action={
          <Link to={{ name: "projects" }} className={buttonClass("primary", "md")}>
            <ArrowLeft aria-hidden="true" className={styles.linkIcon} />
            All projects
          </Link>
        }
      />
    </main>
  );
}
